import React, { useState } from "react";
import { getUser } from "../../auth";
import CreateProductForm from "../components/CreateProductForm";

const URL = process.env.REACT_APP_API_URL;

export default function CreateProduct({ open, onClose, productTypes, empresaRubro }) {
  const [name, setName] = useState("");
  const [pType, setPType] = useState(""); // Product Type
  const [sellMethod, setSellMethod] = useState("Unidad");
  const [quantityReference, setQuantityReference] = useState(100);
  const [unit, setUnit] = useState("gr");
  const [price, setPrice] = useState("");
  const [message, setMessage] = useState("");

  const handleReset = () => {
    setName("");
    setPType("");
    setSellMethod("Unidad");
    setQuantityReference(100);
    setPrice("");
    setMessage("");
  };

  const handleReferenceChange = (e) => {
    const inputValue = Number(e.target.value);
    if (unit === "kg") {
      setQuantityReference(inputValue * 1000); // Almacena en gramos
    } else {
      setQuantityReference(inputValue);
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name || !pType || !price) {
      console.error("Todos los campos son obligatorios");
      return;
    }
    
    const user = getUser();
    const productData = {
      empresa_id: user?.empresa_id,
      name,
      type_id: pType,
      sell_method: sellMethod,
      quantity_reference: sellMethod === "Unidad" ? 1 : Number(quantityReference),
      price: Number(price),
    };

    try {
      const response = await fetch(`${URL}/api/products/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(productData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        if (errorData.detail === "Product already exists") {
          setMessage("El producto ya existe. Por favor, inténtelo de nuevo.");
        } else {
          setMessage(
            "Error al crear el producto. Por favor, inténtelo de nuevo."
          );
        }
      } else {
        setMessage("Producto creado con éxito");
        handleReset();
        onClose();
      }
    } catch (error) {
      console.error("Error en la peticion. Inténtelo de nuevo");
    }
  };
  return (
    <CreateProductForm
      open={open}
      onClose={onClose}
      onSubmit={handleSubmit}
      onReset={handleReset}
      name={name}
      pType={pType}
      price={price}
      productTypes={productTypes}
      message={message}
      setName={setName}
      setPType={setPType}
      sellMethod={sellMethod}
      setSellMethod={setSellMethod}
      quantityReference={quantityReference}
      setQuantityReference={setQuantityReference}
      unit={unit}
      setUnit={setUnit}
      handleReferenceChange={handleReferenceChange}
      setPrice={setPrice}
      empresaRubro={empresaRubro}
    />
  );
}
